const mailValidation = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

// Form Validation
const $form = $('.js-form-validate form, .js-form-validation');
const formErrorClass = 'is-form-error'
const errorClass = 'has-error'

$form.on('submit', function(e) {
  let isValid = true;
  const $this = $(this);
  const $fields = $this.find('.js-required-field');
  const $mail = $this.find('.js-required-mail');
  const $checkboxes = $this.find('.js-required-checkbox');
  const $passTarget = $this.find('.js-pass');
  const $passConfirm = $this.find('.js-pass-confirm');

  $this.removeClass(formErrorClass);

  if ($fields.length) {
    $fields.each(function() {
      const $_this = $(this);

      if ($_this.val() == '') {
        isValid = false;
        $_this.closest('.form__row').addClass(errorClass);
      } else {
        $_this.closest('.form__row').removeClass(errorClass);
      }
    });
  };

  if ($mail.length) {
    $mail.each(function() {
      const $_this = $(this);

      if ($_this.val() == '' || !mailValidation.test($_this.val())) {
        isValid = false;
        $_this.closest('.form__row').addClass(errorClass);
      } else {
        $_this.closest('.form__row').removeClass(errorClass);
      }
    });
  };

  if ($checkboxes.length) {
    $checkboxes.each(function() {
      const $_this = $(this);

      if (!$_this.is(':checked')) {
        isValid = false;
        $_this.closest('.form__row').addClass(errorClass);
      } else {
        $_this.closest('.form__row').removeClass(errorClass);
      }
    });
  }

  if ($passConfirm.length && $passTarget.length) {
    if ($passConfirm.val() == $passTarget.val()) {
      $passConfirm.closest('.form__row').removeClass(errorClass);
    } else {
      isValid = false;
      $passConfirm.closest('.form__row').addClass(errorClass);
    }
  };

  if (!isValid) {
    const $rowError = $this.find(`.form__row.${errorClass}`);

    $this.addClass(formErrorClass);

    return false;
  }
});
